import { isEmpty } from 'helpers/lodash'

import { getNotes as getNotesApi } from '../../services/apis/note'
import { fetchNotesMessages } from '../actions/WebSocket'

export const getNotes = roomName => {
    return dispatch => {
        getNotesApi(roomName)
            .then(response => {
                const { notes, error } = response.data
                if (error) {
                    console.log(
                        'error in getting notes :- ',
                        response.data.error
                    )
                    return
                } else if (!isEmpty(notes)) {
                    dispatch(
                        fetchNotesMessages(
                            notes.map(note => ({
                                note: {
                                    ...note,
                                },
                            }))
                        )
                    )
                }
            })
            .catch(error => {
                console.log('error in getting notes :- ', error)
            })
    }
}
